import styled from 'styled-components'

import theme from '~/truck/theme'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    flex-basis: calc(50% - ${theme.spacing.cozy}px);
    flex-grow: 1;
  }

  > :nth-child(even) {
    margin-left: ${theme.spacing.compact}px;
  }

  > :nth-child(odd):not(:last-child) {
    margin-right: ${theme.spacing.compact}px;
  }
`
